import { create } from "zustand";

interface MedicationsState {
    medications: { 
      medication_name?: string; 
      dosage?: string; 
      cost?: string 
      duration?: string
      vitamin?: string
      instructions?: string;
      refill?: number;
    }[];
    addMedication: () => void;
    updateMedication: (index: number, field: keyof MedicationItem, value: string) => void;
    removeMedication: (index: number) => void;
  }
  
  type MedicationItem = {
    medication_name?: string;
    dosage?: string;
    cost?: string;
    duration?: string;
    vitamin?: {
      name?: string
    };
    instructions?: string;
    refill?: number;
  };
  
  export const useMedicationsStore = create<MedicationsState>((set) => ({
    medications: [],
    addMedication: () => set((state) => ({ 
      medications: [...state.medications, { medication_name: '', dosage: '', cost: '', duration: '', instructions: '', refill: 0 }] 
    })),
    updateMedication: (index, field, value) => set((state) => {
      const newMedications = [...state.medications];
      if (index >= 0 && index < newMedications.length) {
        newMedications[index] = { ...newMedications[index], [field]: value };
      }
      return { medications: newMedications };
    }),
    removeMedication: (index) => set((state) => ({
      medications: state.medications.filter((_, i) => i !== index)
    }))
  }));